import React from "react";

import { ITags } from "@formant/core/model/ITags";

type ITagPillsProps = {
    tags: ITags;
    className?: string;
};

export const TagPills: React.FC<ITagPillsProps> = ({ tags, className }) => {
    if (!tags || Object.keys(tags).length === 0) {
        return null;
    }

    return (
        <div className={`flex flex-wrap gap-1 ${className || ""}`}>
            {Object.entries(tags).map(([key, value], index) => (
                <div
                    key={index}
                    className="flex items-center bg-gray-700 text-white text-sm px-2 py-1 rounded"
                >
                    <span>
                        {key}: {value}
                    </span>
                </div>
            ))}
        </div>
    );
};
